
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesReceiptDialog extends Common.GridEditorDialog<GiftVoucherSalesReceiptRow> {
        protected getFormKey() { return GiftVoucherSalesReceiptForm.formKey; }
        //protected getIdProperty() { return GiftVoucherSalesReceiptRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherSalesReceiptRow.localTextPrefix; }
        //protected getNameProperty() { return GiftVoucherSalesReceiptRow.nameProperty; }
        //protected getService() { return GiftVoucherSalesReceiptService.baseUrl; }
        //protected getDeletePermission() { return GiftVoucherSalesReceiptRow.deletePermission; }
        //protected getInsertPermission() { return GiftVoucherSalesReceiptRow.insertPermission; }
        //protected getUpdatePermission() { return GiftVoucherSalesReceiptRow.updatePermission; }
        static customerid: number;
        protected form = new GiftVoucherSalesReceiptForm(this.idPrefix);
        constructor() {
            super();

            this.element.width(250);

            this.form.ModeId.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();

                Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
                if (ledger.Type == 280) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);

                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    this.form.Scheme.cascadeField = "CustomerId";
                    if (GiftVoucherSalesReceiptDialog.customerid == undefined) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }
                this.form.RefNo.value = "";
                this.form.Scheme.value = "";

            });
            this.form.RefNo.changeSelect2(e => {
                var details = GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                amount = 0;
                for (var i = 0; i < details.length; i++) {
                    amount += details[i].Amount;
                }
                this.form.Amount.value = amount;
                if (details[0].IsPartial) {

                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                } else { Serenity.EditorUtils.setReadOnly(this.form.Amount, false); }
            });
            this.form.Amount.changeSelect2(e => {
                if (this.form.ModeId.value == "283") {
                    if (this.form.Amount.value > amount) {
                        Q.alert('Gift Voucher Limit Exceded');
                        this.form.Amount.value = amount;
                        return;
                    }
                }
            });
            this.form.Scheme.changeSelect2(e => {
                //var schemedetails = Scheme.SchemeEnrollmentRow.getLookup().itemById[this.form.Scheme.value];
                //var totalamount = schemedetails.SchemeAmount + schemedetails.BonusValue;
                var totalamount = 0;

                Scheme.SchemeMasterService.Retrieve({
                    EntityId: parseInt(this.form.Scheme.value)
                }, response => {
                    totalamount = response.Entity.SchemeAmount + response.Entity.BonusValue;
                }, { async: false });
                this.form.Amount.value = totalamount;
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ModeId.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.ModeId.value];
                if (ledger.Type == 283) {
                    var details = GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                    amount = 0;
                    for (var i = 0; i < details.length; i++) {
                        amount += details[i].Amount;
                    }
                }
                else if (ledger.Type == 283) {
                    q.hideField(this.form.Scheme, false);
                }

                if (ledger.Type == 280) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);

                    q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    this.form.Scheme.cascadeField = "CustomerId";
                    if (GiftVoucherSalesReceiptDialog.customerid == undefined) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }


            } else {
                q.hideField(this.form.Scheme, true);
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
            }
        }
    }
}